import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Icon, IconButton, RyeconErrorOutline } from '@dbt-labs/sourdough';
import { RyeconClose } from '@dbt-labs/sourdough';

import { getHumanReadableErrorType } from '../../../../../components/Lineage/ColumnLineageView';

type ColumnErrorPanelHeaderProps = {
  errorCategory: string | null;
};

export const ColumnErrorPanelHeader: FC<ColumnErrorPanelHeaderProps> = ({
  errorCategory,
}) => {
  const setSearchParams = useSearchParams()[1];

  return (
    <div
      className="flex w-full border-b border-borderMuted p-4"
      data-testid="column-error-panel-header"
    >
      <span className="flex-1">
        <div className="flex items-center text-fgDanger">
          <Icon className="flex-0 mr-1" ryecon={RyeconErrorOutline} />
          <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
            {getHumanReadableErrorType(errorCategory)}
          </span>
        </div>
      </span>
      <span className="flex-0 flex space-x-2">
        <IconButton
          size="sm"
          ryecon={RyeconClose}
          className="flex-0 p-1 align-middle"
          label="Close"
          tooltip="Close"
          testId="close-column-error-panel-button"
          onClick={() => {
            setSearchParams((params) => {
              params.delete('selectedColumn');
              return params;
            });
          }}
        />
      </span>
    </div>
  );
};
